import { polyfill } from 'mobile-drag-drop'

polyfill({ holdToDrag: 150 })
